@for (category of projectAnalysisDefinition?.categories; track trackCategory(categoryIndex, category); let categoryIndex = $index) {
    <div class="prevent-pagebreak-inside">
        <vwui-table [compactable]="false">
            <div slot="table-title">{{ categoryIndex + 1 }}. {{ category.name }}</div>
            <vwui-table-row>
                <vwui-table-header class="table-col table-col--nr">{{ 'PAGE_FILL_QUICKSCAN.table.column.nr' | translate }}</vwui-table-header>
                <vwui-table-header class="table-col table-col--question">{{ 'PAGE_FILL_QUICKSCAN.table.column.question' | translate }}</vwui-table-header>
                <vwui-table-header class="table-col table-col--answer-and-remark">{{ 'PAGE_FILL_QUICKSCAN.table.column.answer' | translate }}</vwui-table-header>
                <vwui-table-header class="table-col table-col--score">{{ 'PAGE_FILL_QUICKSCAN.table.column.score' | translate }}</vwui-table-header>
            </vwui-table-row>
            @for (question of category.questions; track trackCategoryQuestion(questionIndex, question); let questionIndex = $index) {
                <vwui-table-row>
                    <vwui-table-column class="table-col table-col--nr">{{ categoryIndex + 1 }}.{{ questionIndex + 1 }}</vwui-table-column>
                    <vwui-table-column class="table-col table-col--question">
                        <div>{{ question.name }}</div>
                        @if (question.info) {
                            <small class="pdf-page__project-note"><vwui-icon iconName="info"></vwui-icon>{{ question.info }}</small>
                        }
                        @if (hasQuestionRemark(question)) {
                            <small class="pdf-page__project-note"><vwui-icon iconName="chat"></vwui-icon>{{ getQuestionRemark(question) }}</small>
                        }
                    </vwui-table-column>
                    <vwui-table-column class="table-col table-col--answer-and-remark">{{ getQuestionAnswer(question) }}</vwui-table-column>
                    <vwui-table-column class="table-col table-col--score"></vwui-table-column>
                </vwui-table-row>
            }
            <vwui-table-row>
                <vwui-table-column class="table-col table-col--nr"></vwui-table-column>
                <vwui-table-column class="table-col table-col--question">
                    @if (hasCategoryRemark(category)) {
                        <small class="pdf-page__project-note pdf-page__project-note--bottom"><vwui-icon iconName="chat"></vwui-icon>{{ getCategoryRemark(category) }}</small>
                    }
                </vwui-table-column>
                <vwui-table-column class="table-col table-col--answer-and-remark"></vwui-table-column>
                <vwui-table-column class="table-col table-col--score"></vwui-table-column>
            </vwui-table-row>
        </vwui-table>
        <div class="grid-spacer grid-spacer--large"></div>
    </div>
}
